export function getIsNavOpen(state) {
  return state.nav.isOpen;
}
